import { Ref, computed, ref } from 'vue';

export default function useTableRowSelection<T>(selectableIds: Ref<T[]>) {
  const selectedIds = ref(new Set<T>()) as Ref<Set<T>>;

  const visibleIds = computed(() => new Set(selectableIds.value));
  const selectedVisibleIds = computed(() =>
    [...selectedIds.value].filter((id) => visibleIds.value.has(id)),
  );
  const selectedVisibleCount = computed(() => selectedVisibleIds.value.length);

  const headerChecked = computed(() => {
    const total = visibleIds.value.size;
    return total > 0 && selectedVisibleCount.value === total;
  });
  const headerIndeterminate = computed(
    () =>
      selectedVisibleCount.value > 0 &&
      selectedVisibleCount.value < visibleIds.value.size,
  );

  function isSelected(id: T) {
    return selectedIds.value.has(id);
  }
  function toggle(id: T) {
    if (selectedIds.value.has(id)) selectedIds.value.delete(id);
    else selectedIds.value.add(id);
  }
  function onHeaderChecked(checked: boolean) {
    selectableIds.value.forEach((id) => {
      if (checked) selectedIds.value.add(id);
      else selectedIds.value.delete(id);
    });
  }
  function clear() {
    selectedIds.value = new Set();
  }

  return {
    selectedIds,
    selectedVisibleIds,
    selectedVisibleCount,
    headerChecked,
    headerIndeterminate,
    isSelected,
    toggle,
    onHeaderChecked,
    clear,
  };
}
